import React from 'react';
import PersonRoundedIcon from '@material-ui/icons/PersonRounded';

import { EditableList } from 'components/List';
import { UPDATE_SHOW_CREATOR } from 'graphql/show';
import { ShowCreator } from 'types';

import CreatorsDialog from './CreatorsDialog';

interface Props {
  creators: any[];
  itunesId: string;
}

const Creators: React.FC<Props> = (props) => {
  const { itunesId, creators } = props;

  const renderEditDialog = (
    isOpen: boolean,
    onClose: () => void,
    selectedCreator?: ShowCreator,
  ) => (
    <CreatorsDialog
      isOpen={isOpen}
      itunesId={itunesId}
      creator={selectedCreator}
      isEditing={!!selectedCreator}
      onClose={onClose}
    />
  );

  return (
    <EditableList
      title="Creators"
      itunesId={itunesId}
      items={creators}
      showOrderActions={creators.length > 1}
      showDeleteActions
      primaryTextKey="name"
      secondaryTextKey="role"
      inputItemNameKey="creator"
      updateMutation={UPDATE_SHOW_CREATOR}
      renderLeftIcon={() => <PersonRoundedIcon />}
      renderEditDialog={renderEditDialog}
    />
  );
};

export default Creators;
